// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cesium-cesiumInspector {
  border-radius: 5px;
  transition: width ease-in-out 0.25s;
  background: rgba(48, 51, 54, 0.8);
  border: 1px solid #444;
  color: #edffff;
  display: inline-block;
  position: relative;
  padding: 4px 12px;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  overflow: hidden;
}

.cesium-cesiumInspector-button {
  text-align: center;
  font-size: 11pt;
}

.cesium-cesiumInspector-visible .cesium-cesiumInspector-button {
  border-bottom: 1px solid #aaa;
  padding-bottom: 3px;
}

.cesium-cesiumInspector input:enabled,
.cesium-cesiumInspector-button {
  cursor: pointer;
}

.cesium-cesiumInspector-visible {
  width: 185px;
  height: auto;
}

.cesium-cesiumInspector-hidden {
  width: 122px;
  height: 17px;
}

.cesium-cesiumInspector-sectionContent {
  max-height: 600px;
}

.cesium-cesiumInspector-section-collapsed
  .cesium-cesiumInspector-sectionContent {
  max-height: 0;
  padding: 0 !important;
  overflow: hidden;
}

.cesium-cesiumInspector-dropDown {
  margin: 5px 0;
  font-family: sans-serif;
  font-size: 10pt;
  width: 185px;
}

.cesium-cesiumInspector-frustumStatistics {
  padding-left: 10px;
  padding: 5px;
  background-color: rgba(80, 80, 80, 0.75);
}

.cesium-cesiumInspector-pickButton {
  background-color: rgba(0, 0, 0, 0.3);
  border: 1px solid #444;
  color: #edffff;
  border-radius: 5px;
  padding: 3px 7px;
  cursor: pointer;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin: 0 auto;
}

.cesium-cesiumInspector-pickButton:focus {
  outline: none;
}

.cesium-cesiumInspector-pickButton:active,
.cesium-cesiumInspector-pickButtonHighlight {
  color: #000; /* For text buttons */
  background: #adf;
  border-color: #fff;
  box-shadow: 0 0 8px #fff;
}

.cesium-cesiumInspector-center {
  text-align: center;
}

.cesium-cesiumInspector-sectionHeader {
  font-weight: bold;
  font-size: 10pt;
  margin: 0;
  cursor: pointer;
}

.cesium-cesiumInspector-pickSection {
  border: 1px solid #aaa;
  border-radius: 5px;
  padding: 3px;
  margin-bottom: 5px;
}

.cesium-cesiumInspector-sectionContent {
  margin-bottom: 10px;
  transition: max-height 0.25s;
}

.cesium-cesiumInspector-tileText {
  padding-bottom: 10px;
  border-bottom: 1px solid #aaa;
}

.cesium-cesiumInspector-relativeText {
  padding-top: 10px;
}

.cesium-cesiumInspector-sectionHeader::before {
  margin-right: 5px;
  content: "-";
  width: 1ch;
  display: inline-block;
}

.cesium-cesiumInspector-section-collapsed
  .cesium-cesiumInspector-sectionHeader::before {
  content: "+";
}
`, "",{"version":3,"sources":["webpack://./cesium/Source/Widgets/CesiumInspector/CesiumInspector.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,iCAAiC;EACjC,sBAAsB;EACtB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,WAAW,EAAE,qBAAqB;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,UAAU;EACV,qBAAqB;AACvB;;AAEA;;EAEE,YAAY;AACd","sourcesContent":[".cesium-cesiumInspector {\n  border-radius: 5px;\n  transition: width ease-in-out 0.25s;\n  background: rgba(48, 51, 54, 0.8);\n  border: 1px solid #444;\n  color: #edffff;\n  display: inline-block;\n  position: relative;\n  padding: 4px 12px;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  overflow: hidden;\n}\n\n.cesium-cesiumInspector-button {\n  text-align: center;\n  font-size: 11pt;\n}\n\n.cesium-cesiumInspector-visible .cesium-cesiumInspector-button {\n  border-bottom: 1px solid #aaa;\n  padding-bottom: 3px;\n}\n\n.cesium-cesiumInspector input:enabled,\n.cesium-cesiumInspector-button {\n  cursor: pointer;\n}\n\n.cesium-cesiumInspector-visible {\n  width: 185px;\n  height: auto;\n}\n\n.cesium-cesiumInspector-hidden {\n  width: 122px;\n  height: 17px;\n}\n\n.cesium-cesiumInspector-sectionContent {\n  max-height: 600px;\n}\n\n.cesium-cesiumInspector-section-collapsed\n  .cesium-cesiumInspector-sectionContent {\n  max-height: 0;\n  padding: 0 !important;\n  overflow: hidden;\n}\n\n.cesium-cesiumInspector-dropDown {\n  margin: 5px 0;\n  font-family: sans-serif;\n  font-size: 10pt;\n  width: 185px;\n}\n\n.cesium-cesiumInspector-frustumStatistics {\n  padding-left: 10px;\n  padding: 5px;\n  background-color: rgba(80, 80, 80, 0.75);\n}\n\n.cesium-cesiumInspector-pickButton {\n  background-color: rgba(0, 0, 0, 0.3);\n  border: 1px solid #444;\n  color: #edffff;\n  border-radius: 5px;\n  padding: 3px 7px;\n  cursor: pointer;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  margin: 0 auto;\n}\n\n.cesium-cesiumInspector-pickButton:focus {\n  outline: none;\n}\n\n.cesium-cesiumInspector-pickButton:active,\n.cesium-cesiumInspector-pickButtonHighlight {\n  color: #000; /* For text buttons */\n  background: #adf;\n  border-color: #fff;\n  box-shadow: 0 0 8px #fff;\n}\n\n.cesium-cesiumInspector-center {\n  text-align: center;\n}\n\n.cesium-cesiumInspector-sectionHeader {\n  font-weight: bold;\n  font-size: 10pt;\n  margin: 0;\n  cursor: pointer;\n}\n\n.cesium-cesiumInspector-pickSection {\n  border: 1px solid #aaa;\n  border-radius: 5px;\n  padding: 3px;\n  margin-bottom: 5px;\n}\n\n.cesium-cesiumInspector-sectionContent {\n  margin-bottom: 10px;\n  transition: max-height 0.25s;\n}\n\n.cesium-cesiumInspector-tileText {\n  padding-bottom: 10px;\n  border-bottom: 1px solid #aaa;\n}\n\n.cesium-cesiumInspector-relativeText {\n  padding-top: 10px;\n}\n\n.cesium-cesiumInspector-sectionHeader::before {\n  margin-right: 5px;\n  content: \"-\";\n  width: 1ch;\n  display: inline-block;\n}\n\n.cesium-cesiumInspector-section-collapsed\n  .cesium-cesiumInspector-sectionHeader::before {\n  content: \"+\";\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
